<template>
  <div class="user-filters-container">
    <btn
      :btn-text="$t('cmrad.see_filters')"
      class="show-filters ml-0 my-3"
      variant="outline-primary"
      icon-name="fa-eye"
      icon
      @click="check"
    >
      <i class="fa fa-chevron-down fa-fw ml-2"></i>
    </btn>
    <div :class="{ checked: checked }" class="user-filters filters-container mt-4">
      <b-row>
        <b-col sm="3" class="mb-2">
          <filter-sections
            :value="getFilterValue('section')"
            :is-multiple="false"
            @input="onValueInput('section', $event)"
          />
        </b-col>
        <b-col sm="3" class="mb-2">
          <filter-institutions :value="getFilterValue('hospital')" @input="onValueInput('hospital', $event)" />
        </b-col>
        <b-col sm="3" class="mb-2">
          <filter-countries :value="getFilterValue('country')" @input="onValueInput('country', $event)" />
        </b-col>
        <b-col v-if="withSort" sm="3" class="position-relative mb-2">
          <label for="user-filters-sort inline-block" class="ordering-label d-none d-md-block">
            {{ $t('cmrad.order_by') }}
          </label>
          <form-select
            id="user-filters-sort"
            :value="getFilterValue('orderBy', 'followers_count')"
            :options="orderByOptions"
            @input="onValueInput('orderBy', $event)"
          />
        </b-col>
      </b-row>
      <b-row class="mt-1 align-items-center pl-3">
        <div v-if="withFollowing">
          <btn
            :btn-text="$t('cmrad.following')"
            :pressed="followingEnabled"
            variant="outline-primary"
            class="follow-btn mr-2"
            size="sm"
            svg-icon
            @click="onFollowingToggle"
          >
            <follow-icon />
          </btn>
        </div>

        <div class="flex-fill">
          <a class="btn-link" href="#" @click.stop.prevent="onClear">clear all</a>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'UserFilters',

    components: {
      FilterInstitutions: () => import('@/Molecules/FilterInstitutions'),
      FilterCountries: () => import('@/Molecules/FilterCountries'),
      FilterSections: () => import('@/Molecules/FilterSections'),
      FollowIcon: () => import('@/Atoms/svgIcons/FollowIcon'),
      FormSelect: () => import('@/Atoms/FormSelect'),
    },

    props: {
      withFollowing: { type: Boolean, default: true },
      withSort: { type: Boolean, default: true },
      value: Object,
    },

    data: () => ({
      saving: false,
      checked: false,
    }),

    computed: {
      ...mapGetters(['isVeheri']),
      ...mapGetters({
        currentUser: 'getCurrentUserResource',
      }),

      followingEnabled() {
        return !!this.getFilterValue('following', false);
      },

      orderByOptions() {
        return [
          {
            value: 'created_at',
            text: this.$t('cmrad.recently_joined'),
          },
          {
            value: 'karma',
            text: this.$t('cmrad.most_karma'),
          },
          {
            value: 'cases_count',
            text: this.$t('cmrad.most_cases'),
          },
          {
            value: 'followers_count',
            text: this.$t('cmrad.most_followers'),
          },
        ];
      },
    },

    methods: {
      check() {
        this.checked = !this.checked;
      },
      onClear() {
        this.$emit('input', {});
      },

      getFilterValue(key, defaultValue = undefined) {
        return this.value[key] || defaultValue;
      },

      onValueInput(key, value) {
        return this.$emit('input', { ...this.value, [key]: value });
      },

      onFollowingToggle() {
        this.onValueInput('following', !this.followingEnabled);
      },
    },
  };
</script>
<style lang="scss" scoped>
  @import '../../sass/config/variables';
  .follow-btn {
    svg {
      height: 1.2rem;
    }
    &.active {
      box-shadow: none;
      svg {
        fill: var(--white);
      }
    }
  }
  .ordering-label {
    white-space: nowrap;
    position: absolute;
    top: -30px;
    left: 15px;
    font-size: 0.83rem;
  }
</style>
